module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background-color": "#fffbf6"
    }
  }, [_c('carousel-page', {
    attrs: {
      "type": 3
    }
  }), _vm._v(" "), _c('introduce-page', {
    attrs: {
      "id": "yewujieshao",
      "type": "业务介绍",
      "url": "static/assets/images/train/01.png"
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "feature-area section-padding2",
    staticStyle: {
      "background-image": "url(\"static/assets/images/train/bg.png\")"
    },
    attrs: {
      "id": "yeliangdian"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "justify-content": "space-between"
    }
  }, _vm._l((_vm.lightspotList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "col-lg-4 pRelative"
    }, [_c('img', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "src": item.titleImage,
        "alt": "红色培训"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "trainLd"
    }, [_c('h4', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('p', {
      domProps: {
        "innerHTML": _vm._s(item.content)
      }
    })])])
  }), 0)])]), _vm._v(" "), _c('section', {
    staticClass: "feature-area section-padding2",
    attrs: {
      "id": "xuexijianshen"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "background-color": "#fff",
      "border-radius": "10px",
      "box-shadow": "0px 0px 20px 0px rgba(179,33,33,0.1)",
      "padding": "20px 0px"
    }
  }, [_c('div', {
    staticClass: "col-lg-2",
    staticStyle: {
      "padding": "0"
    }
  }, _vm._l((_vm.learnList), function(item, index) {
    return _c('div', {
      key: index,
      class: _vm.pitchLearn == index ? 'cutLearnItem' : 'learnItem',
      on: {
        "click": function($event) {
          _vm.pitchLearn = index
        }
      }
    }, [_c('div', [_vm._v(_vm._s(item.title))])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, _vm._l((_vm.learnList), function(item, index) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.pitchLearn == index),
        expression: "pitchLearn==index"
      }],
      key: index
    }, [_c('div', {
      staticClass: "imgWarp"
    }, _vm._l((item.titleImage.split(",")), function(nape, j) {
      return _c('img', {
        staticStyle: {
          "width": "49%",
          "height": "380px",
          "border-radius": "6px"
        },
        attrs: {
          "mode": "aspectFill",
          "src": nape,
          "alt": item.title
        }
      })
    }), 0), _vm._v(" "), _c('p', {
      domProps: {
        "innerHTML": _vm._s(item.content)
      }
    })])
  }), 0)])])]), _vm._v(" "), _c('section', {
    staticClass: "feature-area section-padding2",
    staticStyle: {
      "background-image": "url(\"static/assets/images/train/bg02.png\")",
      "background-size": "100% 100%"
    },
    attrs: {
      "id": "kechenganpai"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(2), _vm._v(" "), _c('div', {}, [_c('div', {
    staticClass: "row flexJCenter"
  }, _vm._l((_vm.courseInfo), function(item, index) {
    return _c('div', {
      staticClass: "col-lg-5 textCenter",
      staticStyle: {
        "margin-bottom": "20px"
      },
      on: {
        "click": function($event) {
          return _vm.showDiv(item.content)
        }
      }
    }, [_c('img', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "src": item.titleImage,
        "alt": item.title
      }
    })])
  }), 0)])])]), _vm._v(" "), _c('section', {
    staticClass: "feature-area section-padding2",
    attrs: {
      "id": "tesekecheng"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "justify-content": "space-between"
    }
  }, _vm._l((_vm.featureInfo), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "col-lg-4 pRelative",
      on: {
        "click": function($event) {
          return _vm.showDiv(item.content)
        }
      }
    }, [_c('img', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "src": item.titleImage,
        "alt": item.title
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "trainKc"
    }, [_c('h4', [_vm._v(_vm._s(item.title))])])])
  }), 0)])]), _vm._v(" "), _c('contact-page', {
    attrs: {
      "id": "lianxiwomen"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isMagnify),
      expression: "isMagnify"
    }],
    staticClass: "isMagnifyDiv",
    on: {
      "click": function($event) {
        _vm.isMagnify = false
      }
    }
  }, [_c('div', {
    staticClass: "magnifyDivContent"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.htmlContent)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "fbgWarp"
  }, [_c('div', {
    staticClass: "fbgTextWarp"
  }, [_c('div', {
    class: _vm.cutFbgTextIndex == 0 ? "cutFbgTextItem" : "fbgTextItem",
    on: {
      "click": function($event) {
        return _vm.cutIndex(0)
      }
    }
  }, [_vm._v("业务介绍")]), _vm._v(" "), _c('div', {
    class: _vm.cutFbgTextIndex == 1 ? "cutFbgTextItem" : "fbgTextItem",
    on: {
      "click": function($event) {
        return _vm.cutIndex(1)
      }
    }
  }, [_vm._v("业务亮点")]), _vm._v(" "), _c('div', {
    class: _vm.cutFbgTextIndex == 2 ? "cutFbgTextItem" : "fbgTextItem",
    on: {
      "click": function($event) {
        return _vm.cutIndex(2)
      }
    }
  }, [_vm._v("学习精神")]), _vm._v(" "), _c('div', {
    class: _vm.cutFbgTextIndex == 3 ? "cutFbgTextItem" : "fbgTextItem",
    on: {
      "click": function($event) {
        return _vm.cutIndex(3)
      }
    }
  }, [_vm._v("课程安排")]), _vm._v(" "), _c('div', {
    class: _vm.cutFbgTextIndex == 4 ? "cutFbgTextItem" : "fbgTextItem",
    on: {
      "click": function($event) {
        return _vm.cutIndex(4)
      }
    }
  }, [_vm._v("特色课程")]), _vm._v(" "), _c('div', {
    class: _vm.cutFbgTextIndex == 5 ? "cutFbgTextItem" : "fbgTextItem",
    on: {
      "click": function($event) {
        return _vm.cutIndex(5)
      }
    }
  }, [_vm._v("联系我们")])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "section-top text-center"
  }, [_c('h2', {
    staticClass: "title borderCDE",
    staticStyle: {
      "z-index": "100",
      "position": "relative"
    }
  }, [_vm._v("业务亮点")]), _vm._v(" "), _c('p', {
    staticClass: "titleShadow",
    staticStyle: {
      "z-index": "0",
      "color": "#caa4a4"
    }
  }, [_vm._v("BUSINESS HIGHLIGHTS")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "section-top text-center"
  }, [_c('h2', {
    staticClass: "title borderCDE",
    staticStyle: {
      "z-index": "100",
      "position": "relative"
    }
  }, [_vm._v("学习精神")]), _vm._v(" "), _c('p', {
    staticClass: "titleShadow",
    staticStyle: {
      "z-index": "0"
    }
  }, [_vm._v("LEARNING SPIRIT")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "section-top text-center"
  }, [_c('h2', {
    staticClass: "title borderCDE",
    staticStyle: {
      "z-index": "100",
      "position": "relative"
    }
  }, [_vm._v("课程安排")]), _vm._v(" "), _c('p', {
    staticClass: "titleShadow",
    staticStyle: {
      "z-index": "0",
      "color": "#caa4a4"
    }
  }, [_vm._v("TEACHING HIGHLIGHT")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "section-top text-center"
  }, [_c('h2', {
    staticClass: "title borderCDE",
    staticStyle: {
      "z-index": "100",
      "position": "relative"
    }
  }, [_vm._v("特色课程")]), _vm._v(" "), _c('p', {
    staticClass: "titleShadow",
    staticStyle: {
      "z-index": "0"
    }
  }, [_vm._v("BUSINESS HIGHLIGHTS")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0937e6c0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Train.vue
// module id = 94
// module chunks = 1